<template>
  <div>
    <TitlePage :title="$t('test')+' '+$t('booking')"></TitlePage>

    <v-layout wrap>
      <p>Cancel</p>

    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapActions, mapMutations} from "vuex";

export default {
  name: "BookingsCancel",
  components: {TitlePage},
  data() {
    return {
    }
  },
  async created() {
    this.setLoading(true);
    await this.rollback({order:this.$route.query.token})
    this.$router.push('/bookings/test')
    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'rollback': 'bookings/rollback'
    }),
  },
  mounted() {
  },
}
</script>

<style scoped>

</style>